<template>
	<div class="home">
		<section class="home_text_box">
			<span class="look_here">看这里<i class="iconfont icon-right"></i></span>
			<div class="clear"></div>
			<h1>葡萄酒行业千万富翁孵化器</h1>
			<p>全方位产品销售平台 </p>
			<p>	可持续盈利的市场模式 </p>
			<p>	全智能销管存一体化系统 </p>
			<p>	全新客户消费体验方案提供者
			</p>
			<div>
				<video-player class="video-player vjs-custom-skin"
			      ref="videoPlayer"
			      :playsinline="true"
			      :options="playerOptions"
			      @play="onPlayerPlay($event)"
			      @pause="onPlayerPause($event)"
			  >
			 </video-player>
			</div>
		</section>
	</div>
</template>

<script>

import homeJs from './home.js';
export default homeJs;
</script>

<style>
	.home{
		color: #fff;
		-webkit-font-smoothing: antialiased;/*使低像素图标字体更清晰*/
	    -moz-osx-font-smoothing: grayscale;
	    background-image: url('../../assets/images/home.png'); /*背景图片地址*/
		background-repeat: no-repeat;/*背景图片不重复*/
		background-size: cover;/*背景图片拉伸铺满*/
		width: 100%; /* 宽度为100%；*/
		height: 100%;
		position: relative;
		margin: 0 auto;
	}
	.home_text_box{
		width: 40%;
		height: 80%;
		padding-top: 5%;
		padding-left: 5%;
		box-sizing: border-box;
	}
	.look_here{
		background: #c4a174;
		padding: 5px;
		width: 100px;
		text-align: left;
		display: inline-block;
		float: right;
	}
	.look_here i{
		font-size: x-large;
		font-weight: bold;
		float: right;
	}
	.clear {
	    clear: both;
	}
	.home_text_box>h1{
		line-height: 2;
	}
	.home_text_box>p{
		line-height: 2;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue